export default "__VITE_ASSET__f565c1a7__"